module.exports = __webpack_public_path__ + "media/images/career_camp/2023/footer-bg-0a9a0a8b723c9ef59b90859ef2051555.png";